// Definizioni dei questionari per ogni categoria — TOP-TEC

export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_maintenance-match-4/artifacts/iqu094st_intestazione-scritta-nosfondo-new.png";

export const CATEGORIES = {
  incollare: {
    slug: "incollare",
    title: "Incolla / Sigilla",
    subtitle: "Adesivi, sigillanti e nastri tecnici",
    image: "https://images.unsplash.com/photo-1607400201515-c2c41c07d307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxjb25zdHJ1Y3Rpb24lMjBjYXVsayUyMHNpbGljb25lfGVufDB8fHx8MTc4NDI5MDM1Nnww&ixlib=rb-4.1.0&q=85",
    code: "01",
  },
  lubrificare: {
    slug: "lubrificare",
    title: "Lubrifica",
    subtitle: "Oli, grassi e lubrificanti tecnici",
    image: "https://images.unsplash.com/photo-1524514587686-e2909d726e9b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbHVicmljYXRpb24lMjBnZWFycyUyMG1lY2hhbmljc3xlbnwwfHx8fDE3ODQyOTAzMDV8MA&ixlib=rb-4.1.0&q=85",
    code: "02",
  },
  pulire: {
    slug: "pulire",
    title: "Pulisci",
    subtitle: "Detergenti, sgrassanti e sanificanti",
    image: "https://images.unsplash.com/photo-1532634766-c2761df5daba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwbWFjaGluZXJ5JTIwY2xlYW5pbmclMjBzZXJ2aWNlfGVufDB8fHx8MTc4NDI5MDMyNnww&ixlib=rb-4.1.0&q=85",
    code: "03",
  },
  protettivi: {
    slug: "protettivi",
    title: "Proteggi",
    subtitle: "Protettivi, anticorrosivi, cere e film",
    image: "https://images.unsplash.com/photo-1601362840469-51e4d8d58785?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
    code: "04",
  },
};

const materialOptions = [
  "Acciaio", "Inox", "Ferro", "Altro metallo", "Leghe",
  "Alluminio", "Plastica", "Materiali sintetici", "Plexiglass",
  "Vetro", "Specchi", "Gomma",
  "Legno", "Ceramica", "Cemento", "Carta/Cartone", "Tessuto",
  "Superfici verniciate",
];

const briefDescriptionQuestion = (placeholder) => ({
  id: "brief_description",
  label: "Breve descrizione della lavorazione",
  type: "textarea",
  placeholder,
  optional: true,
});

const briefIncollare = briefDescriptionQuestion(
  "Descrivi in poche parole cosa devi fare (es. 'sigillare un giunto di dilatazione tra pannelli in alluminio esposto al sole')"
);
const briefLubrificare = briefDescriptionQuestion(
  "Descrivi in poche parole cosa devi lubrificare (es. 'lubrificare la catena di una trasmissione esposta a polvere e acqua')"
);
const briefPulire = briefDescriptionQuestion(
  "Descrivi in poche parole cosa devi pulire (es. 'rimuovere grasso e residui di olio da componenti meccanici in acciaio')"
);
const briefProteggere = briefDescriptionQuestion(
  "Descrivi in poche parole cosa devi proteggere (es. 'proteggere una carrozzeria in alluminio dalla corrosione salina in ambiente marino')"
);

// Termostabilità range (da...a) — comune a più categorie
const thermostabilityQuestion = {
  id: "temp_range",
  label: "Termostabilità richiesta (°C)",
  hint: "Intervallo di temperatura a cui il prodotto sarà esposto",
  type: "range",
  fields: [
    { key: "temp_min", label: "Da", placeholder: "es. -20" },
    { key: "temp_max", label: "A", placeholder: "es. +90" },
  ],
};

// Predicate: skip if user selected "guaina" among product_type options (guaine termorestringenti non hanno spessore/cure time/verniciatura tradizionali)
const skipIfGuainaSelected = (answers) => {
  const pt = answers?.product_type;
  return Array.isArray(pt) && pt.includes("guaina");
};

// Predicate: skip if user picked "aria/ambienti" as cleaning_target (patina, risciacquo, pH non pertinenti per sanificazione dell'aria)
const skipIfCleaningAir = (answers) => answers?.cleaning_target === "air";

export const QUESTIONS = {
  incollare: [
    briefIncollare,
    { id: "product_type", label: "Tipo di prodotto (puoi sceglierne più di uno)", type: "checkboxes",
      options: [
        { value: "nastro", label: "Nastro biadesivo" },
        { value: "colla", label: "Colla / Adesivo" },
        { value: "sigillante", label: "Sigillante" },
        { value: "guaina", label: "Guaina (congiunzione/isolamento cavi e tubi)" },
      ] },
    { id: "form", label: "Forma del prodotto (puoi sceglierne più di una)", type: "checkboxes", optional: true,
      options: [
        { value: "liquida", label: "Liquida" },
        { value: "aerosol", label: "Aerosol" },
        { value: "gel", label: "Gel" },
        { value: "schiuma", label: "Schiuma" },
        { value: "guaina", label: "Guaina (per cavi/tubi)" },
        { value: "nastro", label: "Nastro" },
      ] },
    { id: "material1", label: "Materiale 1", type: "select", options: materialOptions },
    { id: "material2", label: "Materiale 2", type: "select", options: materialOptions },
    { id: "stress", label: "Tipo di sollecitazione (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "statica", label: "Statica" },
        { value: "vibrazioni_urti", label: "Vibrazioni / Urti" },
        { value: "trazione", label: "Trazione" },
        { value: "taglio", label: "Taglio" },
        { value: "strappo", label: "Strappo" },
        { value: "torsione", label: "Torsione" },
      ] },
    thermostabilityQuestion,
    { id: "resistance", label: "Resistenze richieste (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "uv", label: "Raggi UV" },
        { value: "water", label: "Acqua" },
        { value: "oils", label: "Oli" },
        { value: "greases", label: "Grassi" },
      ] },
    { id: "flexibility", label: "Elasticità o rigidità (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "elastica", label: "Elastica" },
        { value: "semi", label: "Semi-elastica" },
        { value: "rigida", label: "Rigida" },
      ] },
    { id: "thickness", label: "Spessore da incollare (mm)", type: "number", placeholder: "es. 2.5", skip_if: skipIfGuainaSelected },
    { id: "cure_time", label: "Tempo massimo di incollaggio (minuti)", type: "number", placeholder: "es. 30", skip_if: skipIfGuainaSelected },
    { id: "color", label: "Colore desiderato", type: "text", placeholder: "es. trasparente, bianco, nero" },
    { id: "paintable", label: "Deve essere verniciabile?", type: "boolean", skip_if: skipIfGuainaSelected },
  ],
  lubrificare: [
    briefLubrificare,
    { id: "application", label: "Dove va applicato", type: "text", placeholder: "es. ingranaggi, catene, cuscinetti" },
    { id: "form", label: "Forma del prodotto (puoi sceglierne più di una)", type: "checkboxes", optional: true,
      options: [
        { value: "liquida", label: "Liquida" },
        { value: "aerosol", label: "Aerosol" },
        { value: "gel", label: "Gel" },
        { value: "schiuma", label: "Schiuma" },
        { value: "cera", label: "Cera" },
      ] },
    { id: "material1", label: "Materiale 1", type: "select", options: materialOptions },
    { id: "material2", label: "Materiale 2 (opzionale)", type: "select", options: [""].concat(materialOptions), optional: true },
    thermostabilityQuestion,
    { id: "stress", label: "Tipo di movimento (puoi sceglierne più di uno)", type: "checkboxes",
      options: [
        { value: "statico", label: "Statico" },
        { value: "dinamico_rotazione", label: "Dinamico / Rotazione" },
        { value: "scorrimento", label: "Scorrimento / Scivolamento" },
        { value: "alta_pressione", label: "Alta pressione" },
        { value: "catene_funi", label: "Catene / Funi" },
      ] },
    { id: "resistance", label: "Resistenze richieste (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "water", label: "Acqua" },
        { value: "acids", label: "Acidi" },
        { value: "chemicals", label: "Agenti chimici" },
        { value: "weather", label: "Intemperie" },
        { value: "antistatic", label: "Antistatico" },
        { value: "oils_greases", label: "Oli e grassi" },
        { value: "dust_dirt", label: "Polvere e sporco" },
      ] },
    { id: "water_repellent", label: "Deve essere idrorepellente?", type: "boolean" },
    { id: "forbidden_substance", label: "Sostanze che NON deve contenere", type: "text", placeholder: "es. silicone, PTFE, grafite" },
  ],
  pulire: [
    briefPulire,
    { id: "cleaning_target", label: "Cosa vuoi pulire / purificare?",
      hint: "Distinguere aiuta il sistema a proporre i prodotti giusti",
      type: "radio",
      options: [
        { value: "surface", label: "Superfici (macchinari, pavimenti, piani, componenti…)" },
        { value: "air", label: "Aria / ambienti (purificazione, sanificazione ambientale)" },
      ] },
    { id: "application", label: "Dove va applicato", type: "text", placeholder: "es. superfici, pavimenti, macchinari" },
    { id: "material1", label: "Tipo di materiale", type: "select", options: materialOptions },
    { id: "protective_film", label: "Deve lasciare una patina protettiva?", type: "boolean", skip_if: skipIfCleaningAir },
    { id: "rinse_required", label: "Richiede risciacquo?", type: "boolean", skip_if: skipIfCleaningAir },
    { id: "ph_range", label: "pH desiderato",
      hint: "Intervallo di pH accettabile (0=acido forte, 7=neutro, 14=basico forte)",
      type: "range",
      skip_if: skipIfCleaningAir,
      fields: [
        { key: "ph_min", label: "Da", placeholder: "es. 6" },
        { key: "ph_max", label: "A", placeholder: "es. 8" },
      ],
    },
    { id: "antibacterial", label: "Deve essere antibatterico?", type: "boolean" },
    { id: "form", label: "Forma del prodotto (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "liquida", label: "Liquida" },
        { value: "aerosol", label: "Aerosol" },
        { value: "gel", label: "Gel" },
        { value: "schiuma", label: "Schiuma" },
        { value: "guaina", label: "Guaina (per cavi/tubi)" },
      ] },
  ],
  protettivi: [
    briefProteggere,
    { id: "application", label: "Su cosa va applicato", type: "text", placeholder: "es. carrozzeria, superfici metalliche, legno esterno" },
    { id: "material1", label: "Materiale principale", type: "select", options: materialOptions },
    { id: "protection_type", label: "Tipo di protezione (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "anticorrosivo", label: "Anticorrosivo" },
        { value: "idrorepellente", label: "Idrorepellente" },
        { value: "anti-graffiti", label: "Anti-graffiti" },
        { value: "cera", label: "Cera protettiva" },
        { value: "film", label: "Film protettivo" },
        { value: "guaina", label: "Guaina isolante (cavi/tubi)" },
        { value: "paraspigoli", label: "Paraspigoli (protezione da spigoli vivi)" },
      ] },
    thermostabilityQuestion,
    { id: "resistance", label: "Resistenze richieste (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "uv", label: "Raggi UV" },
        { value: "water", label: "Acqua" },
        { value: "salts", label: "Salsedine" },
        { value: "chemicals", label: "Agenti chimici" },
        { value: "weather", label: "Intemperie" },
        { value: "antistatic", label: "Antistatico" },
        { value: "oils_greases", label: "Oli e grassi" },
        { value: "dust_dirt", label: "Polvere e sporco" },
      ] },
    { id: "treatment_duration", label: "Tipo di trattamento",
      hint: "Temporaneo: rimovibile con solventi/sostanze pulenti. Definitivo: permanente e non rimovibile.",
      type: "radio",
      options: [
        { value: "temporary", label: "Temporaneo / Removibile" },
        { value: "permanent", label: "Definitivo" },
      ] },
    { id: "form", label: "Forma del prodotto (puoi sceglierne più di una)", type: "checkboxes",
      options: [
        { value: "liquida", label: "Liquida" },
        { value: "aerosol", label: "Aerosol / Spray" },
        { value: "gel", label: "Gel" },
        { value: "cera", label: "Cera" },
        { value: "film", label: "Film / Pellicola" },
        { value: "guaina", label: "Guaina termorestringente" },
      ] },
  ],
};

// Merge opzioni dinamiche (da API /wizard-options) nelle domande statiche.
// Casi speciali: "stress" ha default DIVERSI per categoria (stress_incollare vs stress_lubrificare).
export const DYNAMIC_OPTION_KEYS = ["resistance", "form", "protection_type"];

export function mergeDynamicOptions(questionsByCategory, dynamicOpts) {
  if (!dynamicOpts) return questionsByCategory;
  const result = {};
  for (const [cat, list] of Object.entries(questionsByCategory)) {
    result[cat] = list.map((q) => {
      // "stress" è category-specific: prende stress_<category>
      if (q.id === "stress") {
        const key = `stress_${cat}`;
        if (Array.isArray(dynamicOpts[key])) {
          return { ...q, options: dynamicOpts[key] };
        }
        return q;
      }
      if (DYNAMIC_OPTION_KEYS.includes(q.id) && Array.isArray(dynamicOpts[q.id])) {
        return { ...q, options: dynamicOpts[q.id] };
      }
      return q;
    });
  }
  return result;
}

// Merge lista materiali dinamica (da API /materials-list) nelle domande material1/material2.
// La lista viene ordinata alfabeticamente lato backend; qui viene mappata a stringhe pure.
export function mergeMaterialsList(questionsByCategory, materialsList) {
  if (!Array.isArray(materialsList) || materialsList.length === 0) {
    return questionsByCategory;
  }
  const result = {};
  for (const [cat, list] of Object.entries(questionsByCategory)) {
    result[cat] = list.map((q) => {
      if (q.id === "material1") {
        return { ...q, options: materialsList };
      }
      if (q.id === "material2") {
        // material2 in alcune categorie ha "" come primo elemento per rendere opzionale
        const hasEmpty = Array.isArray(q.options) && q.options[0] === "";
        return { ...q, options: hasEmpty ? [""].concat(materialsList) : materialsList };
      }
      return q;
    });
  }
  return result;
}
